import { render, staticRenderFns } from "./AddCohortRowCard.vue?vue&type=template&id=f37f16c0"
import script from "./AddCohortRowCard.vue?vue&type=script&lang=js"
export * from "./AddCohortRowCard.vue?vue&type=script&lang=js"
import style0 from "./AddCohortRowCard.vue?vue&type=style&index=0&id=f37f16c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports